import { differenceInSeconds, DisplayDate } from 'owa-datetime';
import { createAbbreviatedFormatter } from 'owa-duration-formatter/lib/abbreviated';
import strings from 'owa-strings/owa-agenda-strings';
import { format } from 'owa-strings';
import { isWithinRange } from 'owa-datetime';
import { SECONDS_PER_MINUTE } from 'owa-date-constants';

let abbreviatedFormatterDuration = null;

export function getDurationString(start: DisplayDate, end: DisplayDate): string {
    const diff = differenceInSeconds(end, start);

    if (abbreviatedFormatterDuration == null) {
        abbreviatedFormatterDuration = createAbbreviatedFormatter(
            {
                maxUnits: 1,
                maxFractionalDigits: 1,
            },
            ['minute', 'day', 'hour', 'second']
        );
    }

    return abbreviatedFormatterDuration(diff);
}

let abbreviatedFormatterTimeUntil = null;

/**
 * gets string describing time until an upcoming or current meeting today
 * @param start start date for a meeting today
 * @param end end date for a meeting today
 * @param now current time
 */
export function getTimeUntilString(start: DisplayDate, end: DisplayDate, now: DisplayDate): string {
    const isEventHappeningNow = isWithinRange(now, start, end);
    const diffInSeconds = differenceInSeconds(start, now);
    if (isEventHappeningNow || diffInSeconds <= SECONDS_PER_MINUTE) {
        return strings.agendaEventNowText;
    }
    /** round to the current minute so that there is no seconds count down */
    const roundedDiffInSeconds = roundToCurrentMinute(diffInSeconds);

    if (abbreviatedFormatterTimeUntil == null) {
        abbreviatedFormatterTimeUntil = createAbbreviatedFormatter({
            maxUnits: 2,
        });
    }

    return format(
        strings.agendaEventInXTimeText,
        abbreviatedFormatterTimeUntil(roundedDiffInSeconds)
    );
}

function roundToCurrentMinute(diffInSeconds: number): number {
    const extra = diffInSeconds % SECONDS_PER_MINUTE;
    return diffInSeconds - extra + SECONDS_PER_MINUTE;
}
